module.exports = __webpack_public_path__ + "img/animation.18f8b002.gif";